/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum NotificationType {
    All_JOB_FUNCTION_MEMBERS = 0,
    ACTIVE_JOB_FUNCTION_MEMBERS = 1,
    EMAILS = 2,
}
